import React from 'react'
import { withTranslation } from 'react-i18next'
import PaneHeader from '../../tools/panes/PaneHeader'

const SaveEditShapeTooltip = ({
  title,
  itemName,
  description,
  onSave,
  onCancel,
  onClose,
  t
}) => {
  const handleSave = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    if (onSave) onSave()
  }

  const handleCancel = (e) => {
    if (e && e.stopPropagation) e.stopPropagation()
    if (onCancel) onCancel()
    else if (onClose) onClose()
  }

  return (
    <div
      className='click-tooltip save-edit-shape-tooltip'
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <PaneHeader
        title={title || t('ITEM.EDIT_SHAPE', { defaultValue: 'Edit shape' })}
        onClose={handleCancel}
      />

      <form onSubmit={handleSave}>
        <div className='tooltip-field' style={{ marginBottom: '18px' }}>
          {itemName && (
            <span style={{ fontSize: '13.5px', fontWeight: 600, color: '#1E293B', marginBottom: '4px', display: 'block' }}>
              {itemName}
            </span>
          )}
          <span style={{ fontSize: '12.5px', color: '#64748B', lineHeight: '18px', display: 'block' }}>
            {description || t('ITEM.EDIT_SHAPE_DESC', { defaultValue: 'Adjust the points on the map, then click Confirm to save your changes.' })}
          </span>
        </div>

        <div className='tooltip-actions'>
          <button
            type='button'
            className='btn-cancel'
            onClick={handleCancel}
          >
            {t('GLOBAL.CANCEL', { defaultValue: 'Cancel' })}
          </button>
          <button
            type='submit'
            className='btn-submit'
          >
            {t('GLOBAL.CONFIRM_SAVE', { defaultValue: 'Confirm' })}
          </button>
        </div>
      </form>
    </div>
  )
}

export default withTranslation()(SaveEditShapeTooltip)
